module.exports = __webpack_public_path__ + "static/media/00-mobile.181b95e3.webp";